import request from '@/utils/request'

const url='/positions';

export function getPositions(params) {
  return request({
    url: url + '/listAll',
    method:'get',
    params:params
  })
}
export function positionsList(params) {
  return request({
    url: url + '/poslist',
    method:'get',
    params:params
  })
}


export function getPayAmount(params) {
  return request({
    url: url + '/getPayAmount',
    method:'get',
    params:params
  })
}

export function downExam(params) {
  return request({
    url: url + '/downExam',
    method:'post',
    params:params
  })
}





// WEBPACK FOOTER //
// ./src/api/positions.js